import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "Components/ReactstrapSlim";


export interface BlockedUserModalProps {
   type: LSCommon.Models.BlockedUserMessageType,
   firstName: string,
}

export const BlockedUserModal: React.FC<BlockedUserModalProps> = ({ type, firstName }) => {
   const [isOpen, setIsOpen] = useState(type != LSCommon.Models.BlockedUserMessageType.None);

   const toggle = () => {
      setIsOpen((open) => !open);
   }

   useEffect(() => {
      if (isOpen && type == LSCommon.Models.BlockedUserMessageType.Blocked) {
         if (typeof dataLayer === "object") {
            dataLayer.push({ "event": "trackMemberLoginBlocked" });
         }
      }
   }, [isOpen])

   return (<Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle} className="h7">
         {
            type == LSCommon.Models.BlockedUserMessageType.Blocked
               ? "Account blocked"
               : type == LSCommon.Models.BlockedUserMessageType.Locked
                  ? "Account locked"
                  : ""
         }
      </ModalHeader>
      <ModalBody className="ls-modal-body">
         {
            type == LSCommon.Models.BlockedUserMessageType.Blocked
               ? <>
                  {firstName ? `${firstName}, your` : "Your"} account has been blocked.
                  To re-activate your account please contact <a href="mailto:support@liquidspace.com">support@liquidspace.com</a> or +1&nbsp;(855)&nbsp;257-2665.
               </>
               : type == LSCommon.Models.BlockedUserMessageType.Locked
                  ? <>
                     {firstName ? `${firstName}, your` : "Your"} account has been locked.
                     Please check your email for password restore email.
                     If you have any questions please contact <a href="mailto:support@liquidspace.com">support@liquidspace.com</a> or +1&nbsp;(855)&nbsp;257-2665.
                  </>
                  : null
         }
      </ModalBody>
   </Modal>)
}